import React from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import TasksPage from './TasksPage';
import { useAuth } from '../../hooks/useAuth';
import { useIsMobile } from '../../hooks/useIsMobile';

function TasksPageWrapper() {
  const { profile } = useAuth();
  const isMobile = useIsMobile();
  const userName = profile?.name || 'Usuário';

  return (
    <div style={{ display: 'flex', height: isMobile ? '100dvh' : '100vh', flexDirection: 'column' }}>
      {!isMobile && <Header subtitle="Tarefas" userName={userName} />}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {!isMobile && <Sidebar activePage="tarefas" />}
        <TasksPage currentSellerId={profile?.seller_id || null} />
      </div>
      {isMobile && <Sidebar activePage="tarefas" />}
    </div>
  );
}

export default TasksPageWrapper;
